module.exports = __webpack_public_path__ + "img/MGH-Nakasu-16.ffce06eb.jpg";